// import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
// import { GoLocation } from "react-icons/go";
// import { MdUpdate } from "react-icons/md";
// import { RiSignalWifiOffLine, RiSignalWifi3Fill } from "react-icons/ri";
// import { RadioTower } from "lucide-react";
// import { useHistory } from "react-router-dom";
// import styled, { css, keyframes } from "styled-components";
// import { HumidityIcon } from "../../assets/icons";
// import { GlobalState } from "../../GlobalState";
// import ThermometerAnim from "../sensor_box/Thermometer";
// import WaterFill from "../sensor_box/WaterFill";
// import Loading from "../utils/loading";
// import Tooltip from "../utils/Tooltip";
// import WaterSense from "../sensor_box/WaterSense";
// import { literToKiloliter } from "../utils/utils";
// // const Container = styled.div`
// //   @media (min-width: 61.313em) {
// //     display: flex;
// //   }
// // `;
// const SensorWrapper = styled.div`
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   cursor: pointer;
//   padding: 0.5rem;

//   border: 2px solid #fff;
//   background-color: #fff;
//   &:hover {
//     border: 2px solid var(--primary);
//   }
//   min-width: 260px;
//   margin-right: 1rem;
// `;


// const SensorValue = styled.h6`
//   font-family: "montserrat-semi-bold";
//   font-size: 1.2rem;
// `;
// const SensorUnit = styled.span`
//   font-family: "montserrat-semi-bold";
//   @media (min-width: 61.313em) {
//     font-size: 1rem;
//   }
// `;

// const SensorIconWrapper = styled.div`
//   height: auto;
//   margin: 0 auto;
//   @media (min-width: 61.313em) {
//     margin: 0.7rem auto;
//   }
// `;

// const TimeElapsed = styled.p`
//   margin: 0.5rem;
//   font-size: 0.7rem;
//   font-weight:bold;
//   text-align: end;
//   @media (min-width: 61.313em) {
//     text-align: end;
//   }
// `;

// const AnimatedIconWrapper = styled.div`
//   display: inline-flex;
//   justify-content: center;
//   border-radius: 50%;
//   width: 40px;
//   height: 40px;
//   vertical-align: middle;
//   position: relative;

//   ${({ online }) =>
//     online &&
//     css`
//       &::after {
//         content: "";
//         position: absolute;
//         top: -4px; 
//         left: 0;
//         width: 100%;
//         height: 100%;
//         border-radius: 50%;
//         animation: ${ripple} 1.5s infinite;
//       }
//     `}
// `;

//          const AnimatedIcon = styled(RadioTower)`
//   ${({ online }) =>
//     online &&
//     css`
//       animation: ${pulse} 1.5s infinite;
//       color: green;
//     `}
// `;

// const blinkingRed = keyframes`
//   0% { opacity: 1; }
//   50% { opacity: 0.3; }
//   100% { opacity: 1; }
// `;

// const BlinkingRadioTower = styled(RadioTower)`
//   color: red;
//   animation: ${blinkingRed} 2s infinite;
// `;

// const pulse = keyframes`
//   0% { opacity: 0.4; transform: scale(0.9); }
//   50% { opacity: 1; transform: scale(1.1); }
//   100% { opacity: 0.4; transform: scale(0.9); }
// `;

// const ripple = keyframes`
//   0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
//   100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
// `;
// const Footer = styled.div`

// display: flex;
// justify-content: space-between;
// align-items: center;
// `


// export default function DashboardSensorBox({ sensor_id, type }) {
//   const state = useContext(GlobalState);
//   const history = useHistory();
//   const [loading, setLoading] = useState(true);
//   const [list, setList] = useState([]);

//   // const sensor_i = sensor_id || match.params.sensor_id
//   useEffect(() => {


//     async function fetchData(token, sensor_id) {
//       try {
//         const sensorReading = await axios.get(`${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor_id}&&type=${type}`,
//           {
//             headers: { Authorization: token[0] },
//           }
//         );

//         if (sensorReading) {

//           setList(sensorReading.data);
//           setLoading(false);
//         }

//       } catch (err) {
//         console.log(err.message);
//       }
//     }
//     fetchData(state.token, sensor_id);

//     const interval = setInterval(() => {
//       fetchData(state.token, sensor_id);
//     }, 8000);

//     return () => clearInterval(interval);
//   }, [state.token, sensor_id, type]);
//   if (loading)
//     return (
//       <Loading />
//     );

//   return (
//     <SensorWrapper
//       onClick={() => {
//         history.push(`/sensor/${sensor_id}/${type}`)
//       }}
//     >

//       <div style={{ display: 'flex', justifyContent: 'space-between' }}>

//         <div style={{ display: 'flex' }}>
//           <GoLocation /> &nbsp;<h5 >{list.location_name ?? list.location}</h5>
//         </div>
//         <div>
//           {/* {list.sensor_status === "online" ? (
//             <RiSignalWifi3Fill size={20} color={'green'} />
//           ) : (
//             <Tooltip
//               content={
//                 <>
//                   Sensor is offline.
//                 </>
//               }
//               direction="left"
//               delay="0"
//             >
//               <RiSignalWifiOffLine size={20} color={'red'} />
//             </Tooltip>
//           )} */}

//           <AnimatedIconWrapper online={list.sensor_status === "online"}>
//             {list.sensor_status === "online" ? (
//               <AnimatedIcon online size={22} strokeWidth={2} color="green" />
//             ) : (
//               <Tooltip content="Sensor is offline." direction="right" delay="0">
//                 <BlinkingRadioTower size={22} strokeWidth={2} color="red" />
//               </Tooltip>
//             )}
//           </AnimatedIconWrapper>
//         </div>
//       </div>

//       <SensorIconWrapper>
//         {
//           list.name.includes("temperature") ? (
//             <ThermometerAnim value={parseFloat(list.value)} />
//           ) : list.name.includes("water-level") || list.name.includes("diesel-level") ? (
//             <WaterFill
//               value={parseFloat(list.volume).toFixed(0)}
//               color={list.volume_color}
//             />
//           ) : list.name.includes("humidity") ? (

//             <div style={{
//               minHeight: '100px',
//               minWidth: '100px',
//             }}>

//               <HumidityIcon />
//             </div>

//           ) : list.name.includes("water-sense") ? (
//             <>
//               <WaterSense value={parseInt(list.value)} />
//             </>
//           ) : (
//             <></>
//           )
//         }

//       </SensorIconWrapper>

//       <Footer><TimeElapsed><MdUpdate /> {list.date} &bull; {list.time}</TimeElapsed>
//         {list.name.includes("water-sense") && (<></>)}
//         {list.name.includes("water-level") ? (<SensorValue style={{ color: `${list.color} ` }}>
//           {literToKiloliter(list.value)}
//         </SensorValue>) :
//           <SensorValue style={{ color: `${list.color} ` }}>
//             {parseFloat(list.value).toLocaleString()}
//             &nbsp;
//             <SensorUnit>
//               {list.unit === "celsius"
//                 ? "°C"
//                 : list.unit === "litre"
//                   ? "L" : list.unit === "percent" ?
//                     "%" : ""}
//             </SensorUnit>
//           </SensorValue>}

//       </Footer>
//     </SensorWrapper>
//   );
// }



// import axios from "axios";
// import React, { useContext, useEffect, useState } from "react";
// import { GoLocation } from "react-icons/go";
// import { MdUpdate } from "react-icons/md";
// import { RadioTower } from "lucide-react";
// import { useHistory } from "react-router-dom";
// import styled, { css, keyframes } from "styled-components";
// import { HumidityIcon } from "../../assets/icons";
// import { GlobalState } from "../../GlobalState";
// import ThermometerAnim from "../sensor_box/Thermometer";
// import WaterSense from "../sensor_box/WaterSense";
// import Loading from "../utils/loading";
// import Tooltip from "../utils/Tooltip";
// import { literToKiloliter } from "../utils/utils";
// import { PiPulse } from "react-icons/pi";

// const blinkingRed = keyframes`
//   0% { opacity: 1; }
//   50% { opacity: 0.3; }
//   100% { opacity: 1; }
// `;

// const pulse = keyframes`
//   0% { opacity: 0.4; transform: scale(0.9); }
//   50% { opacity: 1; transform: scale(1.1); }
//   100% { opacity: 0.4; transform: scale(0.9); }
// `;

// const ripple = keyframes`
//   0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
//   100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
// `;

// const SensorWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 1rem;
//   min-width: 260px;
//   border-radius: 20px;
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   background-color: #fff;
//   cursor: pointer;
//   border: 2px solid #fff;
//   margin-right: 1rem;
//   &:hover {
//     border: 2px solid var(--primary);
//   }
// `;

// const Header = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 0.5rem;
// `;

// const Location = styled.div`
//   display: flex;
//   font-weight: bold;
//   font-size: 0.8rem;
//   gap:10px; 
// `;

// const AnimatedIconWrapper = styled.div`
//   display: inline-flex;
//   justify-content: center;
//   border-radius: 50%;
//   width: 40px;
//   height: 40px;
//   position: relative;
//   ${({ online }) =>
//     online &&
//     css`
//       &::after {
//         content: "";
//         position: absolute;
//         top: -4px;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         border-radius: 50%;
//         animation: ${ripple} 1.5s infinite;
//       }
//     `}
// `;

// const AnimatedIcon = styled(RadioTower)`
//   ${({ online }) =>
//     online &&
//     css`
//       animation: ${pulse} 1.5s infinite;
//       color: green;
//     `}
// `;

// const BlinkingRadioTower = styled(RadioTower)`
//   color: red;
//   animation: ${blinkingRed} 2s infinite;
// `;

// const SensorIconWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   margin: 0.5rem 0;
// `;

// const WaterLevelWrapper = styled.div`
//   width: 80px;
//   height: 100px;
//   border: 2px solid #ccc;
//   border-radius: 8px;
//   background-color: #f5f5f5;
//   display: flex;
//   flex-direction: column-reverse;
//   overflow: hidden;
// `;

// //   const WaterFillBar = styled.div`
// //   width: 100%;
// //   height: ${({ level }) => level}%;  /* 0-100% */
// //   background: linear-gradient(
// //     to top, 
// // rgb(49, 87, 148),   /* dark blue bottom */
// // rgb(120, 146, 171)    /* lighter dark blue top */
// //   );
// //   transition: height 0.5s ease-in-out;
// //   border-radius: 4px 4px 0 0; /* rounded top corners */
// // `;

// const WaterFillBar = styled.div`
//   width: 100%;
//   height: ${({ level }) => level}%;  /* 0-100% */
//   background: linear-gradient(
//     to top, 
//     rgb(25, 76, 204),   /* dark blue bottom */
//     rgb(139, 173, 218)  /* lighter dark blue top */
//   );
//   transition: height 0.5s ease-in-out;
//   border-radius: 4px 4px 0 0; /* rounded top corners */

//   /* Center the text inside the bar */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   font-weight: bold;
//   font-size: 0.9rem;
// `;


// const Footer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-top: 0.5rem;
// `;

// const TimeElapsed = styled.p`
//   font-size: 0.8rem;
//   font-weight: bold;
// `;

// const SensorValue = styled.h6`
//   font-family: "montserrat-semi-bold";
//   font-size: 1.2rem;
// `;

// const SensorUnit = styled.span`
//   font-family: "montserrat-semi-bold";
//   margin-left: 0.2rem;
// `;

// const TankInfoWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.3rem;
//   margin-top: 0.5rem; /* space below footer timestamp */
// `;

// const InfoBox = styled.div`
//   width: 100%;
//   padding: 0.6rem 0.6rem;
//   border-radius: 6px;
//   font-size: 0.8rem;
//   font-weight: bold;
//   color: white;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const CurrentValueBox = styled(InfoBox)`
//   background: linear-gradient(to right,rgb(162, 112, 180),rgb(187, 162, 192)); /* purple gradient */
// `;

// const CapacityBox = styled(InfoBox)`
//   background: linear-gradient(to right,rgb(33, 85, 138),rgb(156, 173, 197)); /* blue gradient */
// `;


// export default function DashboardSensorBox({ sensor_id, type }) {
//   const state = useContext(GlobalState);
//   const history = useHistory();
//   const [loading, setLoading] = useState(true);
//   const [list, setList] = useState([]);

//   useEffect(() => {
//     async function fetchData(token, sensor_id) {
//       try {
//         const sensorReading = await axios.get(
//           `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor_id}&&type=${type}`,
//           { headers: { Authorization: token[0] } }
//         );
//         if (sensorReading) {
//           setList(sensorReading.data);
//           setLoading(false);
//         }
//       } catch (err) {
//         console.log(err.message);
//       }
//     }

//     fetchData(state.token, sensor_id);

//     const interval = setInterval(() => {
//       fetchData(state.token, sensor_id);
//     }, 8000);

//     return () => clearInterval(interval);
//   }, [state.token, sensor_id, type]);

//   if (loading) return <Loading />;

//   const waterLevel =
//     list.name.includes("water-level") || list.name.includes("diesel-level")
//       ? Math.min(100, parseFloat(list.volume))
//       : 0;

//   return (
//     <SensorWrapper onClick={() => history.push(`/sensor/${sensor_id}/${type}`)}>
//       {/* Header: Online/Offline + Location */}
//       <Header>
//         <Location>
//           {/* <GoLocation /> */}
//           <PiPulse size={30} color="#004080" />
//           &nbsp;{list.location_name ?? list.location}
//         </Location>
//         <AnimatedIconWrapper online={list.sensor_status === "online"}>
//           {list.sensor_status === "online" ? (
//             <AnimatedIcon online size={22} strokeWidth={2} />
//           ) : (
//             <Tooltip content="Sensor is offline." direction="right" delay="0">
//               <BlinkingRadioTower size={22} strokeWidth={2} />
//             </Tooltip>
//           )}
//         </AnimatedIconWrapper>
//       </Header>

//       {/* Sensor Icon / Water Level */}
//       <SensorIconWrapper>
//         {list.name.includes("temperature") ? (
//           <ThermometerAnim value={parseFloat(list.value)} />
//         ) : list.name.includes("water-level") || list.name.includes("diesel-level") ? (
//           // <WaterLevelWrapper>
//           //   <WaterFillBar level={waterLevel} color={list.volume_color} />
//           // </WaterLevelWrapper>
//           <WaterLevelWrapper>
//   <WaterFillBar level={waterLevel}>
//     {waterLevel.toFixed(0)}%
//   </WaterFillBar>
// </WaterLevelWrapper>

//         ) : list.name.includes("humidity") ? (
//           <div style={{ minHeight: '100px', minWidth: '100px' }}>
//             <HumidityIcon />
//           </div>
//         ) : list.name.includes("water-sense") ? (
//           <WaterSense value={parseInt(list.value)} />
//         ) : null}
//       </SensorIconWrapper>

//       {/* Footer: Last Updated + Sensor Value */}
//       {/* <Footer>
//         <TimeElapsed>
//           <MdUpdate /> {list.date} &bull; {list.time}
//         </TimeElapsed>

//       </Footer> */}

// {list.name.includes("water-level") && (
//   <TankInfoWrapper>
//     <CurrentValueBox>
//       Current Volume:{" "}
//       {list.unit === "litre"
//         ? literToKiloliter(list.value)  // already includes KL formatting
//         : parseFloat(list.value).toLocaleString()}{" "}
//       {list.unit === "celsius"
//         ? "°C"
//         : list.unit === "percent"
//         ? "%"
//         : ""} {/* no extra "L" here */}
//     </CurrentValueBox>
//   </TankInfoWrapper>
// )}

//     </SensorWrapper>
//   );
// }


import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { GoLocation } from "react-icons/go";
import { MdUpdate } from "react-icons/md";
import { RadioTower } from "lucide-react";
import { useHistory } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import { HumidityIcon } from "../../assets/icons";
import { GlobalState } from "../../GlobalState";
import ThermometerAnim from "../sensor_box/Thermometer";
import WaterSense from "../sensor_box/WaterSense";
import Loading from "../utils/loading";
import Tooltip from "../utils/Tooltip";
import { literToKiloliter, capitalizeFirstLetter } from "../utils/utils";
import { PiPulse } from "react-icons/pi";
import TankDetails from "./TankDetail";
import DoubleRangeSlider from "./DoubleRangeSlider";
import { editAccess } from "../utils/utils";
import { Droplet, Box, Layers } from "lucide-react";

const blinkingRed = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const ripple = keyframes`
  0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
  100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
`;

const SensorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  border-radius: 10px;

  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    border-color: #60a5fa;
    transform: translateY(-1px);
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
`;

const Location = styled.div`
  display: flex;
  // align-items: center;
  font-weight: 600;
  font-size: 0.75rem;
  // color: #1e3a8a;
`;

const AnimatedIconWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  position: relative;
  ${({ online }) =>
    online &&
    css`
      &::after {
        content: "";
        position: absolute;
        top: -2px;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        animation: ${ripple} 1.5s infinite;
      }
    `}
`;

const AnimatedIcon = styled(RadioTower)`
  ${({ online }) =>
    online &&
    css`
      animation: ${pulse} 1.5s infinite;
      color: green;
    `}
`;

const BlinkingRadioTower = styled(RadioTower)`
  color: red;
  animation: ${blinkingRed} 2s infinite;
`;

const SensorIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.3rem 0;
`;

const WaterLevelWrapper = styled.div`
  width: 70px;
  height: 80px;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  background-color: #f9fafb;
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
`;

const WaterFillBar = styled.div`
  width: 100%;
  height: ${({ level }) => level}%;
  background: linear-gradient(to top, rgb(25, 76, 204), rgb(139, 173, 218));
  transition: height 0.4s ease-in-out;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 0.9rem;
`;

const TankInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.4rem;
  align-items: center;
  font-weight: 800;
`;

const InfoBox = styled.div`
  width: 100%;
  padding: 0.4rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff;
  text-align: center;
`;

// const TankInfoWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.5rem;
//   margin-top: 0.4rem;
//   align-items: center;
// `;

const InfoCard = styled.div`
  width: 100%;
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(102, 126, 234, 0.08);
  border: 1px solid rgba(102, 126, 234, 0.2);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(102, 126, 234, 0.12);
    transform: translateX(4px);
  }
`;

const IconCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  flex: 1;
`;

const InfoLabel = styled.span`
  font-size: 0.8rem;
  color:rgb(82, 109, 147);
  font-weight: 700;
`;

const InfoValue = styled.span`
  font-size: 0.8rem;
  color: #1e293b;
  font-weight: 600;
`;

const CurrentValueBox = styled(InfoBox)`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.25);
`;

const ShapeBox = styled(InfoBox)`
  background: linear-gradient(135deg, #a76ec3 0%, #8b5ea8 100%);
  box-shadow: 0 4px 15px rgba(167, 110, 195, 0.25);
`;

const CapacityBox = styled(InfoBox)`
  background: linear-gradient(135deg, #8e6ab8 0%, #9d7ec0 100%);
  box-shadow: 0 4px 15px rgba(142, 106, 184, 0.25);
`;

const gradientShift = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

const pulse = keyframes`
  0%, 100% { 
    transform: scale(1);
  }
  50% { 
    transform: scale(1.05);
  }
`;

const LocationName = styled.p`
  margin: 0;
  font-weight: 1000;
  white-space: nowrap;
  font-size: 0.9rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${({ $isFaulty, $isOnline }) =>
    $isFaulty
      ? "#ef4444"     // Red
      : $isOnline
        ? "#16a34a"     // Green
        : "#ea580c"};   // Orange (offline)

  @media (max-width: 768px) {
    font-size: 0.82rem;
  }
`;

export default function DashboardSensorBox({ sensor_id, type, match, dimension }) {
  const state = useContext(GlobalState);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [data, setData] = useState({});

  useEffect(() => {
    async function fetchData(token, sensor_id) {
      try {
        const sensorReading = await axios.get(
          `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor_id}&&type=${type}`,
          { headers: { Authorization: token[0] } }
        );
        if (sensorReading) {
          setList(sensorReading.data);
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
      }
    }

    fetchData(state.token, sensor_id);
    const interval = setInterval(() => fetchData(state.token, sensor_id), 8000);
    return () => clearInterval(interval);
  }, [state.token, sensor_id, type]);

  if (loading) return <Loading />;

  const waterLevel =
    list.name.includes("water-level") || list.name.includes("diesel-level")
      ? Math.min(100, parseFloat(list.volume))
      : 0;

  return (
    <SensorWrapper onClick={() => history.push(`/sensor/${sensor_id}/${type}`)}>
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>

        <LocationName $isOnline={list.sensor_status === "online"}>
          {list.location_name ?? list.location}
        </LocationName>

        {/* {list.sensor_status !== "online" && (
          <div
            style={{
              background: "#fb923c",
              color: "white",
              fontSize: "0.65rem",
              padding: "2px 6px",
              borderRadius: "4px",
              fontWeight: "700",
            }}
          >
            Offline
          </div>
        )} */}

      </div>


      {/* Sensor Icon */}
      {/* <SensorIconWrapper>
        {list.name.includes("temperature") ? (
          <ThermometerAnim value={parseFloat(list.value)} />
        ) : list.name.includes("water-level") || list.name.includes("diesel-level") ? (
          <WaterLevelWrapper>
            <WaterFillBar level={waterLevel}>{waterLevel.toFixed(0)}%</WaterFillBar>
          </WaterLevelWrapper>
        ) : list.name.includes("humidity") ? (
          <div style={{ minHeight: "70px", minWidth: "70px" }}>
            <HumidityIcon />
          </div>
        ) : list.name.includes("water-sense") ? (
          <WaterSense value={parseInt(list.value)} />
        ) : null}
      </SensorIconWrapper> */}

      {/* Tank Info */}
      {list.name.includes("water-level") && (
        // <TankInfoWrapper>
        //   <CurrentValueBox>
        //     Amount Of Water:{" "}
        //     {list.unit === "litre"
        //       ? literToKiloliter(list.value)
        //       : parseFloat(list.value).toLocaleString()}{" "}
        //     {list.unit === "celsius"
        //       ? "°C"
        //       : list.unit === "percent"
        //       ? "%"
        //       : ""}
        //   </CurrentValueBox>

        //   <ShapeBox>
        //     Tank Shape: {capitalizeFirstLetter(dimension?.tank_shape ?? "")}
        //   </ShapeBox>

        //   <CapacityBox>
        //     Tank Capacity: {literToKiloliter(dimension?.tank_volume || 0)}
        //   </CapacityBox>
        // </TankInfoWrapper>

        <TankInfoWrapper>
          <InfoCard style={{ flexDirection: "column", gap: "0", alignItems: "flex-start" }}>

            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <IconCircle><Droplet size={16} color="#fff" /></IconCircle>
              <InfoContent>
                <InfoLabel>Amount of Water</InfoLabel>
                <InfoValue>
                  {list.unit === "litre"
                    ? literToKiloliter(list.value)
                    : parseFloat(list.value).toLocaleString()}
                </InfoValue>
              </InfoContent>
            </div>

            <div style={{ height: "1px", background: "rgba(102,126,234,0.15)", margin: "6px 0" }} />

            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <IconCircle><Box size={16} color="#fff" /></IconCircle>
              <InfoContent>
                <InfoLabel>Tank Shape</InfoLabel>
                <InfoValue>{capitalizeFirstLetter(dimension?.tank_shape ?? "")}</InfoValue>
              </InfoContent>
            </div>

            <div style={{ height: "1px", background: "rgba(102,126,234,0.15)", margin: "6px 0" }} />

            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <IconCircle><Layers size={16} color="#fff" /></IconCircle>
              <InfoContent>
                <InfoLabel> Total Capacity</InfoLabel>
                <InfoValue>{literToKiloliter(dimension?.tank_volume || 0)}</InfoValue>
              </InfoContent>
            </div>

          </InfoCard>
        </TankInfoWrapper>
      )}
    </SensorWrapper>
  );
}


